export default "__VITE_ASSET__CT5WTYX4__"